// Sesión cacheada en localStorage para que ProtectedRoute pueda entrar sin red
// (P12.4): solo un 401/403 real invalida la sesión; ante Network Error, timeout
// o 5xx se conservan los tokens y se usa el usuario cacheado.
// Lista blanca: /auth/me también devuelve device_fingerprint, registration_ip,
// google_id… que no deben quedar en localStorage.
export const CACHED_USER_FIELDS = [
  'user_id', 'email', 'name', 'role', 'subscription_tier', 'trial_ends_at',
  'selected_profession', 'selected_region', 'selected_country', 'selected_scope',
  'credits', 'xp', 'level', 'streak_days', 'picture',
];

export const cacheUser = (user) => {
  if (!user || !user.user_id) return;
  const picked = {};
  CACHED_USER_FIELDS.forEach((key) => {
    if (user[key] !== undefined) picked[key] = user[key];
  });
  try {
    localStorage.setItem('user', JSON.stringify(picked));
  } catch (_e) {
    // localStorage lleno o bloqueado: la caché es opcional
  }
};

export const readCachedUser = () => {
  try {
    const cached = JSON.parse(localStorage.getItem('user') || 'null');
    return cached && cached.user_id ? cached : null;
  } catch (_e) {
    return null;
  }
};

export const clearSession = () => {
  ['session_token', 'refresh_token', 'user'].forEach((key) => localStorage.removeItem(key));
  try {
    // Purga de la caché de API del SW en dispositivos compartidos; hasta que
    // sw.js atienda este mensaje lo ignora sin efecto.
    navigator.serviceWorker?.controller?.postMessage({ type: 'CLEAR_API_CACHE' });
  } catch (_e) {
    // sin service worker
  }
};

// Solo una respuesta 401/403 del servidor invalida la sesión; sin `response`
// (Network Error, timeout) o con 5xx la sesión puede seguir siendo válida.
export const isSessionInvalidError = (error) => {
  const status = error?.response?.status;
  return status === 401 || status === 403;
};
